/* Keeps [data-et-selected-size] spans in sync with the selected variant's
   size option (PDP-011, mirrors the PDP_010 et-accordion.js mechanism). */
if (!customElements.get('et-size-sync')) {
	class ETSizeSync extends HTMLElement {
		connectedCallback() {
			this.productId = this.dataset.productId
			this.sizeOptionIndex = parseInt(this.dataset.sizeOptionIndex, 10)

			if (!this.productId || this.sizeOptionIndex < 0 || !window.FoxThemeEvents) return

			this.unsubscribeVariantChange = window.FoxThemeEvents.subscribe(
				`${this.productId}__VARIANT_CHANGE`,
				(variant) => this.onVariantChange(variant)
			)
		}

		disconnectedCallback() {
			if (this.unsubscribeVariantChange) this.unsubscribeVariantChange()
		}

		onVariantChange(variant) {
			if (!variant || !variant.options) return
			const size = variant.options[this.sizeOptionIndex]
			if (!size) return
			this.querySelectorAll('[data-et-selected-size]').forEach((el) => {
				el.textContent = size
			})
		}
	}

	customElements.define('et-size-sync', ETSizeSync)
}
